const getTimeTranslation = (minutes: number, seconds: number, lang: string) => {
  const roundedMinutes = minutes === 0 && seconds > 0 ? 1 : minutes
  switch (lang) {
    case 'ar':
      return `(د ${roundedMinutes})`
    case 'en':
    default:
      return `(${roundedMinutes} min)`
  }
}

export default getTimeTranslation
